export default {
  common: {
    button: {
      cancel: 'Cancelar',
      clear: 'Borrar',
      close: 'Cerrar',
      done: 'Finalizado',
      getStarted: 'Empecemos',
      next: 'Siguiente',
      ok: 'Aceptar',
      logOut: 'Cerrar sesión',
      register: 'Registrarse',
      reset: 'Restablecer',
      update: 'Actualizar',
      leaveFeedback: 'Deja un comentario',
      yes: 'Sí',
      no: 'No',
      switchUser: 'Cambiar de usuario'
    },
    connectivity: {
      offline: 'Fuera de línea',
      online: 'En línea'
    },
    emoji: {
      bad: 'Malo',
      good: 'Bueno',
      neutral: 'Neutral',
      perfect: 'Perfecto',
      worst: 'Muy malo'
    },
    misc: {
      copyright: '© 125 Data & Insights Ltd',
      fibLtd: '125 Data & Insights Limited',
      findOutMore: 'Para más información',
      licenseInfo: 'Informació de la licencia',
      loading: 'Cargando',
      miles: 'Millas',
      privacyPolicy: 'AVISO DE PRIVACIDAD DE LA PLATAFORMA',
      total: 'Total'
    },
    placeholder: {
      addYourComments: 'Añada vuestros comentarios...'
    },
    social: {
      email: 'Correo electrónico',
      facebook: 'Facebook',
      google: 'Google',
      tripadvisor: 'Tripadvisor',
      twitter: 'Twitter'
    },
    validation: {
      alphaNumDashes: 'Este campo solo puede contener caracteres a-z, A-Z, guiones, guiones bajos y números del 0 al 9.',
      alphaNumLower: 'Este campo solo puede contener caracteres a-z y números del 0 al 9.',
      anniversary: 'Este campo debe contener una fecha válida en el formato DD/MM',
      DDMM: 'La fecha debe tener el formato día/mes: (dd/mm)',
      DDMMYYYY: 'La fecha debe tener el formato día/mes/año. (dd/mm/yyyy)',
      email: 'Este campo debe contener una dirección de correo electrónico válida',
      futureDateNotAllowed: 'La fecha no puede ser futura',
      match: 'Este campo debe contener un valor coincidente',
      max: 'Este campo no puede contener más de {n} caracteres',
      min: 'Este campo debe contener al menos {n} caracteres',
      numeric: 'Este campo solo puede contener números del 0 al 9',
      required: 'Obligatorio',
      validationFailed: 'Validación fallida',
      validationSuccessful: 'Validación exitosa',
      minValue: 'Not Implemented.' // TODO: Translate (PWA)

    }
  }
};